'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();

import React, { useEffect, useMemo, useRef, useState } from 'react';

import {
    getEnhancedFavorite,
    useContentfulFavorites,
} from 'hooks/useContentfulFavorites';
import { useFavoritesList } from 'hooks/useFavorites';

import ProductResults from './ResultsSections/ProductResults';
import RecipeResults from './ResultsSections/RecipeResults';

import styles from './favorites.module.scss';

const FavoritesPageClient = () => {
    const { allFavorites, initialized } = useFavoritesList();

    // Fetch fresh content from Contentful for all favorites
    const {
        contentfulData,
        isLoading: contentfulLoading,
        error: contentfulError,
    } = useContentfulFavorites(allFavorites);

    // Build a stable key for the current favorites to detect changes
    const favoritesKey = useMemo(() => {
        if (!allFavorites || allFavorites.length === 0) return '';
        return allFavorites
            .map(f => `${f.type}:${f.id}`)
            .sort()
            .join('|');
    }, [allFavorites]);

    // Local syncing state: reset when favorites change; finalize when Contentful finishes
    const lastFavoritesKeyRef = useRef('');
    const [isSyncing, setIsSyncing] = useState(false);

    useEffect(() => {
        if (!initialized) return; // wait until context ready
        if (lastFavoritesKeyRef.current !== favoritesKey) {
            lastFavoritesKeyRef.current = favoritesKey;
            // Only trigger syncing if there is at least one favorite
            setIsSyncing(Boolean(favoritesKey));
        }
    }, [favoritesKey, initialized]);

    useEffect(() => {
        if (!initialized) return;
        if (!contentfulLoading) {
            setIsSyncing(false);
        }
    }, [contentfulLoading, initialized]);

    // Enhance favorites with fresh Contentful data
    const enhancedFavorites = allFavorites.map(favorite =>
        getEnhancedFavorite(favorite, contentfulData)
    );

    // Gate loading to avoid zero-state flashes
    const hasFavorites = favoritesKey !== '';
    const hasContentfulData = Object.keys(contentfulData || {}).length > 0;
    // Track if we have ever loaded Contentful data to avoid skeletons on subsequent syncs
    const hasEverLoadedDataRef = useRef(false);
    useEffect(() => {
        if (hasContentfulData) {
            hasEverLoadedDataRef.current = true;
        }
    }, [hasContentfulData]);
    const hasEverLoadedData = hasEverLoadedDataRef.current;

    // If we have favorites but contentfulData hasn't populated yet (even though
    // contentfulLoading might have just flipped), keep showing skeletons
    const shouldDeferEmpty =
        hasFavorites && !contentfulLoading && !hasContentfulData;

    // Only show skeletons before the first successful Contentful load
    const isLoading =
        !initialized ||
        (!hasEverLoadedData &&
            (contentfulLoading || isSyncing || shouldDeferEmpty));

    // Separate favorites by type and transform to ResultsSections format
    const recipesFavorites = enhancedFavorites.filter(
        favorite => favorite.type === 'recipe'
    );
    const productsFavorites = enhancedFavorites.filter(
        favorite => favorite.type === 'product'
    );

    return (
        <>
            {contentfulError && (
                <div className={styles.errorMessage}>
                    <p>
                        Some content may be outdated. Error: {contentfulError}
                    </p>
                </div>
            )}
            <RecipeResults items={recipesFavorites} isLoading={isLoading} />
            <ProductResults items={productsFavorites} isLoading={isLoading} />
        </>
    );
};

export default FavoritesPageClient;
